export enum KinshipEnum {
  PARENT = "Pai/Mãe",
  GRANDPARENT = "Avô/Avó",
  UNCLE_AUNT = "Tio/Tia",
  SIBLING = "Irmão/Irmã",
  COUSIN = "Primo/Prima",
  LEGAL_GUARDIAN = "Responsável legal",
}

export type KinshipKey = keyof typeof KinshipEnum;
